
import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  getTypeList(params) { //获取类型管理列表
    const url =  baseURL + '/tbType/list';
    return axios.post(url, qs.stringify(params));
  },

  upTypeList(params) { //新增.修改类型管理
    const url =  baseURL + '/tbType/modify';
    return axios.post(url, qs.stringify(params));
  },

  delTypeList(params) { //删除类型管理
    const url =  baseURL + '/tbType/delete';
    return axios.post(url, qs.stringify(params));
  },

}


// WEBPACK FOOTER //
// ./src/api/menu.js